/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Advantage_One_AppInputs */

const en_why_listening_advantage_one_app = /** @type {(inputs: Why_Listening_Advantage_One_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One app for everything you read`)
};

const es_why_listening_advantage_one_app = /** @type {(inputs: Why_Listening_Advantage_One_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una app para todo lo que lees`)
};

/**
* | output |
* | --- |
* | "One app for everything you read" |
*
* @param {Why_Listening_Advantage_One_AppInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_advantage_one_app = /** @type {((inputs?: Why_Listening_Advantage_One_AppInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Advantage_One_AppInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_advantage_one_app(inputs)
	return en_why_listening_advantage_one_app(inputs)
});